export default function (): { redirect: string, oauth: string, type: string, competition: string } {
  const params = new URLSearchParams(window.location.search)

  return Object.freeze({
    redirect: params.get('redirect') || '',
    oauth: params.get('oauth') || '',
    type: params.get('type') || '',
    competition: params.get('competition') || ''
  })
}
